import lenis from './lenis.js';
/**
 * ハンバーガーメニュー
 */

jQuery( function ($) {

  const hamburger    = $( '.js-hamburger' );
  const hamburgerBtn = $( '.c-hamburger' );
  const drawer       = $( '.js-drawer' );
  const focusTrap    = $( '.js-focus-trap' );
  const drawerInner  = $( '.p-drawer__inner' );

  drawerInner.on( 'wheel touchmove' ,(e) => {
    e.stopPropagation()
  })

  // クリックで開閉
  hamburger.on( 'click', function () {
    if ( 'false' === hamburgerBtn.attr('aria-expanded') ) {
      openDrawer();
    } else {
      closeDrawer();
    }
  });

  const openDrawer = () => {
    drawer.attr( 'aria-hidden', 'false' ).focus();
    hamburgerBtn.attr( 'aria-expanded', 'true' );
    hamburgerBtn.attr( 'aria-label', 'メニューを閉じる' );
    lenis.stop();
  }

  const closeDrawer = () => {
    drawer.attr( 'aria-hidden', 'true' ).blur();
    hamburgerBtn.attr( 'aria-expanded', 'false' );
    hamburgerBtn.attr( 'aria-label', 'メニューを開く' );
    lenis.start();
  }

  // フォーカストラップ制御
  focusTrap.on( 'focus', function() {
    hamburgerBtn.focus();
  } );

  $( document ).on( 'keydown', function( e ) {
    if ( e.key === 'Escape' ) {
      closeDrawer( hamburger );
    }
  } );
});
